// ** React Imports
import { useNavigate} from "react-router-dom";
import { memo, useMemo , useEffect, useState} from 'react';

// ** MUI Imports
import { Typography, Box, IconButton } from '@mui/material'
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

// ** Icon Imports
import Icon from '../../../icon'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Tooltip from '@mui/material/Tooltip';

// ** Components
import ModeToggler from '../../../../layouts/components/shared-components/ModeToggler'
import UserDropdown from '../../../../layouts/components/shared-components/UserDropdown'
import SettingsDropdown from '../../../../layouts/components/shared-components/SettingsDropdown'
import NotificationDropdown from '../../../../layouts/components/shared-components/NotificationDropdown'
import { GetOnboardingStatus } from "components/logic/paymentgateway/GetOnboardingStatus";

const AppBarContent = memo((props) => {
  // ** Props
  const { hidden, settings, saveSettings, toggleNavVisibility, pageTitle, showIcon, NavURL } = props

  // ** Hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const smAbove = useMediaQuery(theme.breakpoints.up("sm"));
  const [User, setUser] = useState({});

  useEffect(() => {
      const getUserData = async()=>{
        const response = await GetOnboardingStatus(navigate);
        if(!response.isError){
          setUser(response.result);
        }else{
          setUser({});
          console.error("Error fetching user data:", response.message);
        }
      }
      getUserData();
  
    },[User?.roleType, navigate]);

  const handleBackToOnboarding = () => {
    if(User?.roleType === 'Admin' || User?.roleType === 'Owner' || User?.roleType === 'Manager'){
      navigate('/onboarding');
    }
  }
  // Memoize left actions content
  const leftActionsContent = useMemo(() => (
    <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
      {hidden && !settings.navHidden ? (
        <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
          <Icon fontSize='1.5rem' icon='tabler:menu-2' />
        </IconButton>
      ) : null}
      {showIcon && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, mr: 2 }}>
          <IconButton onClick={NavURL}><ArrowBackIcon /></IconButton>
        </Box>          
      )}
      {smAbove && (
        <Typography variant='h4' fontWeight='bold'>{pageTitle}</Typography>
      )}
    </Box>
  ), [hidden, settings.navHidden, toggleNavVisibility, showIcon, NavURL, smAbove, pageTitle]);

  // Memoize right actions content
  const rightActionsContent = useMemo(() => (
    <Box className='actions-right' sx={{ display: 'flex', alignItems: 'center', ml: 'auto', gap: 2 }}>
        <Tooltip title="Back to Onboarding" placement="bottom">
      <IconButton sx={{
        display: (User?.roleType === 'Admin' || User?.roleType === 'Owner'|| User?.roleType === 'Manager') ? 'block' : 'none'
      }} 
      color='inherit' 
      onClick={() => handleBackToOnboarding()}
      >
        <Icon  fontSize='1.625rem' icon='material-symbols:back-to-tab' />
      </IconButton>
      </Tooltip>
      <ModeToggler />
      <NotificationDropdown />
      <SettingsDropdown />
      <UserDropdown settings={settings} />
    </Box>
  ), [settings, saveSettings,User?.roleType]);

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      {leftActionsContent}
      {rightActionsContent}
    </Box>
  );
});

AppBarContent.displayName = 'AppBarContent';

export default AppBarContent;